import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";

export function useInspectSearchParam(key = "inspect") {
  const [params, setParams] = useSearchParams();
  const selectedId = params.get(key);

  const setSelectedId = useCallback(
    (next: string | null | ((current: string | null) => string | null)) => {
      setParams(
        (current) => {
          const nextParams = new URLSearchParams(current);
          const currentId = nextParams.get(key);
          const value = typeof next === "function" ? next(currentId) : next;
          if (value) nextParams.set(key, value);
          else nextParams.delete(key);
          return nextParams;
        },
        { replace: true },
      );
    },
    [key, setParams],
  );

  return [selectedId, setSelectedId] as const;
}
